<template>
    <el-drawer
        title="调整人脸验证次数"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        :show-close="false"
    >
        <div class="drawer-content">
            <el-form
                :model="formData"
                :rules="rules"
                ref="formData"
                size="mini"
            >
                <el-form-item prop="documentName" label="用户姓名:">
                    {{formData.documentName}}
                </el-form-item>
                <el-form-item prop="documentNumber" label="用户身份证号:">
                    <!-- <el-input placeholder="请输入用户身份证号" v-model="formData.documentNumber"></el-input> -->
                    {{formData.documentNumber}}
                </el-form-item>
            </el-form>
            <div class="MT30">
                <el-alert type="warning" title="注意：" :closable="false">
                    用户首次人脸验证失败的情况下，最多可以再尝试刷3次人脸。<br>如果次数用尽管理员可帮助用户调整人脸验证次数为“3”
                </el-alert>
            </div>
        </div>
        <div class="drawer-footer">
            <el-button v-if="!btnLoading" @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading" :disabled="time > 0"
                >确认调整 {{ time > 0 ? `(${time}S)` : ''}} </el-button
            >
        </div>
    </el-drawer>
</template>

<script>

const defaultFormData = {
    documentNumber: "",
    documentName: ""
}
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading:false,
            formData:{...defaultFormData},
            rules:{
                // documentNumber: [{ required: true, message: "请输入用户身份证号" }],
            },
            time: 5,
            timer: null
        }
    },
    methods:{
        close() {
            this.formData = {...defaultFormData};
            this.$refs['formData'].clearValidate();
            // this.$refs['formData'].resetFields();

            this.time = 5;
            clearInterval(this.timer);

            this.drawerShow = false;
        },
        show(data) {
            this.formData = {
                documentNumber: data.documentNumber,
                documentName: data.documentName
            }
            this.drawerShow = true;

            this.timer = setInterval(() => {
                if( this.time > 0 ){
                    this.time --;
                }else{
                    clearInterval(this.timer);
                }
            },1000)
        },
        // 表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.submitAction()
                } else {
                    return false;
                }
            });
        },
        submitAction(){
            const _url = "/commonPerformer/resetFaceNum";
            this.btnLoading = true;
            this.$request({
                url: _url,
                params: this.formData,
                method: "post",
            })
                .then((res) => {
                    const { state, msg } = res.data;
                    if (state && state == 1) {
                        this.$alert(msg || '已调整验证次数' , "成功", {
                            type: "success",
                            center: true,
                            callback: () => {
                                this.close();
                                this.$emit('onUpdate');
                            }
                        })
                    } else {
                        this.$alert(msg || "操作失败,请重试" , "失败", {
                            type: "error",
                            center: true
                        })
                    }
                })
                .catch(() => {
                    this.$message.error("操作失败,请重试");
                })
                .finally(() => {
                    this.btnLoading = false;
                });   
        }
    }
}
</script>
